export default {
    _Play_Button: 'Play_Button',
    _Try_Again: 'Try_Again',
    _Level_Complete: 'Level_Complete',
    _Placing_Puzzle_Piece: 'Placing_Puzzle_Piece',
    _Jingle: 'Jingle',
    _Letter_Tweens: 'Letter_Tweens',
    _Click: 'Click',
}